// import Sidebar from '../../../components/sidebar/Sidebar'
// import Header from '../../../components/headerbar/Header'
// // import "./product.scss";
// import { useParams, useNavigate } from 'react-router-dom'
// import {config} from '../../../config'
// import { useState, useEffect } from 'react'
// import axios from 'axios'
// import { ToastContainer, toast } from 'react-toastify'
// import 'react-toastify/dist/ReactToastify.css'

// const OptionListEdit = () => {
//   const accesstoken = JSON.parse(localStorage.getItem('user'))
//   const [optionList, setOtionList] = useState([])
//   const navigate = useNavigate()
//   useEffect(() => {
//     getOptionList()
//     getOptionListEdit()
//   }, [])

//   const [title, setTitle] = useState('')

//   const [content, setContent] = useState('')

//   const [image, setImage] = useState('')

//   const [imagepreview, setImagepreview] = useState('')
//   const [imagede, setImagede] = useState('')
//   const [editimg, setImageedit] = useState('')

//   const [updateid, setUpdateid] = useState('')
//   const [error, setError] = useState(false)
//   const params = useParams()

//   const getOptionList = async () => {
//     let bannerresult = await fetch(config.apiurl + '/optionlist/get_optionlist')
//     bannerresult = await bannerresult.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
//     setOtionList(bannerresult.data.results)
//   }

//   const getOptionListEdit = async () => {
//     let optionlistdetails = await fetch(
//       config.apiurl + '/optionlist/' + params.editid,
//       {
//         method: 'get',
//         headers: {
//           Authorization: 'bearer ' + accesstoken.data.access_token,
//         },
//       }
//     )
//     optionlistdetails = await optionlistdetails.json().catch((err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"}))
//     setTitle(optionlistdetails.data[0].title)
//     setContent(optionlistdetails.data[0].content)
//     setImageedit(optionlistdetails.data[0].image)
//     setImage(optionlistdetails.data?.[0].image)
//     if (params) {
//       setImagepreview(config.fileurl + optionlistdetails.data[0].image)
//     }
//   }

//   const handleImageupload = async (event) => {
//     const fileup = event.target.files[0]
//     Transformfile(fileup)
//   }

//   const Transformfile = (file) => {
//     const reader = new FileReader()
//     if (file) {
//       reader.readAsDataURL(file)
//       reader.onloadend = () => {
//         setImage(file.name)
//         setImagepreview(reader.result)
//         setImagede(file)
//       }
//     } else {
//       setImage('')
//       setImagepreview('')
//       setImagede('')
//     }
//   }

//   const submitProductDetails = async (res) => {
//     const editupdateurl = config.apiurl + '/optionlist/' + params.editid
//     const configdata = {
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: 'bearer ' + accesstoken.data.access_token,
//       },
//     }
//     const ondataSuccess = (res) => {
//       if (res?.data?.status?.toLowerCase() === 'true') {
//         toast('Updated successfully')
//         setTimeout(() => {
//           navigate('/optionlist')
//         }, 2000)
//       }
//     }
//     const ondataFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
//     const editdata = {
//       title: title,
//       content: content,
//       image: res,
//     }
//     axios
//       .put(editupdateurl, editdata, configdata)
//       .then(ondataSuccess, ondataFailure)
//   }

//   const handleProsubmit = async () => {
//     if (!image) {
//       setError(true)
//       return false
//     }
//     /*Image Upload process here */
//     if (imagede) {
//       const imageupurl = config.apiurl + '/upload/upload-single'
//       const configimg = {
//         headers: {
//           'content-type': 'multipart/form-data',
//           Authorization: 'bearer ' + accesstoken.data.access_token,
//         },
//       }
//       const formData = new FormData()
//       formData.append('file', imagede)

//       const onSuccess = (response) => {
//         submitProductDetails(response.data.data.filename)
//       }
//       const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
//       axios.post(imageupurl, formData, configimg).then(onSuccess, onFailure)
//     } else {
//       submitProductDetails(editimg)
//     }
//   }

//   return (
//     <>
//       <div className="min-height-300 bg-primary position-absolute w-100"></div>
//       <Sidebar />
//       <main className="main-content position-relative border-radius-lg ">
//         <Header />
//         <div className="container-fluid py-4">
//           <div className="row">
//             <div className="col-12">
//               <div className="card mb-4">
//                 <div className="card-header pb-3">
//                   <div className="row">
//                     <div className="col-6 d-flex align-items-center">
//                       <h6 className="mb-0">Edit OptionList</h6>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="card-body">
//                   <div className="row">
//                     <div className="col-md-4">
//                       <div className="form-group">
//                         <label
//                           htmlFor="example-text-input"
//                           className="form-control-label"
//                         >
//                           Title
//                         </label>
//                         <input
//                           className="form-control"
//                           type="text"
//                           value={title}
//                           onChange={(e) => {
//                             setTitle(e.target.value)
//                           }}
//                         />
//                         {error && !title && (
//                           <span className="text-danger text-gradient text-xs text-secondary">
//                             Enter the product title
//                           </span>
//                         )}
//                       </div>
//                     </div>
//                   </div>

//                   <div className="row">
//                     <div className="col-md-3">
//                       <div className="form-group">
//                         <label
//                           htmlFor="example-text-input"
//                           className="form-control-label"
//                         >
//                           Image
//                         </label>
//                         <input
//                           className="form-control"
//                           type="file"
//                           onChange={(event) => handleImageupload(event)}
//                         />
//                       </div>
//                     </div>
//                     {imagepreview ? (
//                       <div className="col-md-6">
//                         {
//                           <img
//                             src={imagepreview}
//                             alt="img"
//                             width="150"
//                             height="150"
//                           />
//                         }
//                       </div>
//                     ) : null}
//                   </div>
//                   <div className="row">
//                     <div className="col-md-6">
//                       <div className="form-group">
//                         <label
//                           htmlFor="example-text-input"
//                           className="form-control-label"
//                         >
//                           Content
//                         </label>
//                         <textarea
//                           className="form-control"
//                           rows="5"
//                           value={content}
//                           onChange={(e) => {
//                             setContent(e.target.value)
//                           }}
//                         ></textarea>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="row">
//                     <div className="text-end">
//                       <button
//                         type="button"
//                         onClick={handleProsubmit}
//                         className="btn btn-primary btn-sm ms-auto mt-5"
//                       >
//                         Update
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>
//       <ToastContainer />
//     </>
//   )
// }

// export default OptionListEdit

import React from 'react'
import Sidebar from '../../../components/sidebar/Sidebar'
import Header from '../../../components/headerbar/Header'
import {config} from '../../../config'
import { useState, useEffect, useCallback } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useFormik } from 'formik'
import * as yup from 'yup'
import axios from 'axios'
import _ from 'lodash'

const OptionListEdit = () => {
  const navigate = useNavigate()
  const accesstoken = JSON.parse(localStorage.getItem('user'))
  const { id } = useParams()
  const [details, setDetails] = useState(null)

  // Save option list
  const handleOptionList = (formValues) => {
    const data = {
      title: formValues?.title,
      content: formValues?.content,
      image: formValues?.image,
    }
    const url = config.apiurl + `/optionlist/${id}`
    const configdata = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    }
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        toast('OptionList updated successfully')
        setTimeout(() => {
          navigate('/optionlist')
        }, 2000)
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    axios.put(url, data, configdata).then(onSuccess, onFailure)
  }

  const formik = useFormik({
    initialValues: {
      title: '',
      content: '',
      image: '',
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      title: yup
        .string()
        .required('Enter the title')
        .trim()
        .min(3, 'Must be at least 3 characters long')
        .max(250, 'Max 250 characters')
        .nullable(),
      content: yup
        .string()
        .required('Enter the content')
        .trim()
        .min(3, 'Must be at least 3 characters long')
        .max(1000, 'Max 1000 characters')
        .nullable(),
      image: yup.string().required('Choose the image').nullable(),
    }),
    onSubmit: handleOptionList,
  })

  const handleImageupload = (event) => {
    const url = config.apiurl + '/upload/upload-single'
    const configdata = {
      headers: {
        'content-type': 'multipart/form-data',
        Authorization: 'bearer ' + accesstoken.data.access_token,
      },
    }
    const formData = new FormData()
    formData.append('file', event.target.files?.[0])
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        toast('Image added successfully')
        formik?.setFieldValue('image', res?.data?.data?.filename)
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", { type: "error", })
    axios.post(url, formData, configdata).then(onSuccess, onFailure)
  }

  // Get optionlist by id
  const getOptionList = useCallback(() => {
    const url = config.apiurl + `/optionlist/${id}`
    const onSuccess = (res) => {
      if (res?.data?.status?.toLowerCase() === 'true') {
        setDetails(res?.data?.data?.[0])
      }
    }
    const onFailure = (err) => toast(err?.response?.data?.message || err?.response?.data?.error || "Something Went Wrong", {type: "error"})
    axios.get(url).then(onSuccess, onFailure)
  }, [id])
  useEffect(() => {
    getOptionList()
  }, [getOptionList])

  // set values on intial for update
  useEffect(() => {
    if (!_.isEmpty(details)) {
      formik.setFieldValue('title', details?.title)
      formik.setFieldValue('content', details?.content)
      formik.setFieldValue('image', details?.image)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details])

  return (
    <>
      <div className="min-height-300 bg-primary position-absolute w-100"></div>
      <Sidebar />
      <main className="main-content position-relative border-radius-lg ">
        <Header />
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-12">
              <div className="card mb-4">
                <div className="card-header pb-3">
                  <div className="row">
                    <div className="col-6 d-flex align-items-center">
                      <h6 className="mb-0">Add OptionList</h6>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Title
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="title"
                          id="title"
                          value={formik?.values?.title}
                          onChange={formik?.handleChange}
                        />
                        {formik?.errors?.title &&
                          formik?.touched?.title &&
                          formik?.errors?.title && (
                            <span className="text-danger text-gradient text-xs text-secondary">
                              {formik?.errors?.title}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label data-required="true"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Content
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          name="content"
                          id="content"
                          value={formik?.values?.content}
                          onChange={formik?.handleChange}
                        />
                        {formik?.errors?.content &&
                          formik?.touched?.content &&
                          formik?.errors?.content && (
                            <span className="text-danger text-gradient text-xs text-secondary">
                              {formik?.errors?.content}
                            </span>
                          )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label data-required="true"
                          for="files"
                          htmlFor="example-text-input"
                          className="form-control-label"
                        >
                          Image
                        </label>
                        <input
                          className="form-control"
                          type="file"
                          onChange={(event) => handleImageupload(event)}
                        />
                        {formik?.touched?.image && formik?.errors?.image && (
                          <span className="text-danger text-gradient text-xs text-secondary">
                            {formik?.errors?.image}
                          </span>
                        )}
                      </div>
                    </div>
                    {!_.isEmpty(formik?.values?.image) && (
                      <div className="col-md-4 imageWrapper">
                        <div>
                          <img
                            src={config?.fileurl + formik?.values?.image}
                            alt="Product Img"
                            width="150"
                            height="150"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="text-end">
                    <button
                      type="button"
                      onClick={formik?.handleSubmit}
                      className="btn btn-primary btn-sm ms-auto mt-5"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <ToastContainer />
    </>
  )
}

export default OptionListEdit
